// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu-container {
  position: relative;
  display: inline-block;
}

.user-menu-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  color: #333;
}

.user-menu-button:hover {
  background: #f5f5f5;
  border-color: #667eea;
}

.user-icon {
  color: #667eea;
  flex-shrink: 0;
}

.user-name {
  font-weight: 500;
  color: #333;
}

.dropdown-arrow {
  color: #666;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.user-menu-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  z-index: 1000;
  overflow: hidden;
}

.user-menu-item {
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: #333;
  transition: background-color 0.2s ease;
}

.user-menu-item:hover {
  background: #f5f5f5;
}

.user-menu-item.logout {
  color: #d32f2f;
  font-weight: 500;
}

.user-menu-item.logout:hover {
  background: #ffebee;
}

.user-menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 4px 0;
}

.user-menu-section-header {
  padding: 8px 16px 4px 16px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #667eea;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.user-menu-section-description {
  padding: 4px 16px 8px 16px;
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
}

.user-menu-item.disabled {
  color: #999;
  cursor: not-allowed;
  font-style: italic;
}

.user-menu-item.active {
  background: #e3f2fd;
  color: #667eea;
  font-weight: 500;
}












`, "",{"version":3,"sources":["webpack://./src/UserMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".user-menu-container {\n  position: relative;\n  display: inline-block;\n}\n\n.user-menu-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.user-menu-button:hover {\n  background: #f5f5f5;\n  border-color: #667eea;\n}\n\n.user-icon {\n  color: #667eea;\n  flex-shrink: 0;\n}\n\n.user-name {\n  font-weight: 500;\n  color: #333;\n}\n\n.dropdown-arrow {\n  color: #666;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 220px;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.user-menu-item {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #333;\n  transition: background-color 0.2s ease;\n}\n\n.user-menu-item:hover {\n  background: #f5f5f5;\n}\n\n.user-menu-item.logout {\n  color: #d32f2f;\n  font-weight: 500;\n}\n\n.user-menu-item.logout:hover {\n  background: #ffebee;\n}\n\n.user-menu-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 4px 0;\n}\n\n.user-menu-section-header {\n  padding: 8px 16px 4px 16px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #667eea;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.user-menu-section-description {\n  padding: 4px 16px 8px 16px;\n  font-size: 0.85rem;\n  color: #666;\n  font-weight: 500;\n}\n\n.user-menu-item.disabled {\n  color: #999;\n  cursor: not-allowed;\n  font-style: italic;\n}\n\n.user-menu-item.active {\n  background: #e3f2fd;\n  color: #667eea;\n  font-weight: 500;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
